module.exports = __webpack_public_path__ + "img/live-streaming.aaf0d709.svg";